import React from 'react';
import { Route, Router, matchPath } from 'react-router-dom';
import routes from './routes';

export function RouteWithSubRoutes(route) {
  const render = route.render
    ? route.render
    : props => <route.component {...route} {...props} routes={route.routes} />;
  return <Route path={route.path} render={render} />;
}

export function getRoutes(appCenterSchema) {
  return routes(appCenterSchema).map((route, i) => (
    <RouteWithSubRoutes index={i} {...route} />
  ));
}

export function matchRoutes(routes, pathname, /* not public -> */ branch = []) {
  // this below is based on what is done in react-router-config
  // https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
  routes.some(route => {
    let match;
    if (route.path) {
      match = matchPath(pathname, route);
    } else if (branch.length) {
      match = branch[branch.length - 1].match;
    } else {
      match = Router.computeRootMatch(pathname);
    }

    if (match) {
      branch.push({ route, match });
      if (route.routes) {
        matchRoutes(route.routes, pathname, branch); // recursively add matches
      }
    }
    return match;
  });
  return branch;
}

export function getComponents(location, appcenterSchemaItem) {
  let params = {};
  const components = matchRoutes(routes(appcenterSchemaItem), location).map(
    routeMatch => {
      if (routeMatch.match) {
        params = { ...params, ...routeMatch.match.params };
      }
      return routeMatch.route.component || routeMatch.route?.render()?.type;
    }
  );

  return { components, params };
}
